import { apiDaInscricao } from './axios';

export const carregarEtnias = async () => {
  const { data: etnias } = await apiDaInscricao().get('/etnia/ObterTodos');
  return etnias;
};